module.exports = __webpack_public_path__ + "img/sample-report-17@3x.3b051ae7.png";